import { useState } from "react";
import Panel from "./Panel";
import Grid from "./Grid";
import Modal from "./Modal";
import DeleteButton from "./DeleteButton";
import InviteAdd from "./InviteAdd";
import { Check, X } from "lucide-react";
import { useGetQuery, useDeleteQuery } from "../hooks";
import ConfirmationModal from "./ConfirmationModal";
import Actions from "./Actions";
import AddButton from "./AddButton";

export default function InviteCRUD() {
  const invitesQuery = useGetQuery("invites");
  const deleteInvite = useDeleteQuery("invites");

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [deleteModalId, setDeleteModalId] = useState(null);

  if (invitesQuery.isLoading) {
    return null;
  }

  return (
    <Panel left="Invites">
      <Grid
        data={invitesQuery.data}
        columnsTemplate="justify-between grid-cols-[auto_auto_auto]"
        renderTestId={(invite) => `Invite ${invite.email}`}
        columns={[
          { header: "Email", key: "email" },
          {
            header: "Accepted",
            render: (invite) =>
              invite.accepted ? (
                <Check key="accepted" className="w-4 h-4" />
              ) : (
                <X key="not-accepted" className="w-4 h-4" />
              ),
          },
          {
            header: "Actions",
            render: (invite) => (
              <Actions>
                <DeleteButton
                  key="delete"
                  onClick={() => setDeleteModalId(invite.id)}
                />
              </Actions>
            ),
          },
        ]}
      />
      <AddButton className="mt-4" onClick={() => setAddModalOpen(true)} />
      <Modal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        heading="Add Invite"
      >
        <InviteAdd callback={() => setAddModalOpen(false)} />
      </Modal>
      <ConfirmationModal
        isOpen={deleteModalId !== null}
        onClose={() => setDeleteModalId(null)}
        heading="Delete Invite"
        message="Are you sure you want to remove this invite?"
        confirmLabel="Delete"
        onConfirm={() => {
          deleteInvite.mutate(deleteModalId);
          setDeleteModalId(null);
        }}
      />
    </Panel>
  );
}
